import { useEffect, useMemo, useState } from 'react'
import { leaderboardYears } from '../lib/groupTournaments'
import { fetchLeaderboardRankings } from '../services/tournamentService'
import LeaderboardTable from './LeaderboardTable'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'

// The group's overall standings for one calendar year (owner 2026-10-07):
// everyone starts at 0 on January 1, like the global leaderboard, and past
// years stay one pick away. Replaces the all-time total that never reset.
export default function GroupYearLeaderboard({ groupId, brackets }) {
  const years = useMemo(() => leaderboardYears(brackets), [brackets])
  const [year, setYear] = useState(years[0])
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetchLeaderboardRankings({ groupId, year, limit: 100 })
      .then(data => { if (!cancelled) setRows(data || []) })
      .catch(err => {
        console.error('Error loading group leaderboard:', err)
        if (!cancelled) setRows([])
      })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [groupId, year])

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-4">
        <p className="text-sm text-muted-foreground">
          Points from every group tournament that ended in {year}.
        </p>
        <Select value={String(year)} onValueChange={v => setYear(Number(v))}>
          <SelectTrigger className="w-28 flex-shrink-0" aria-label="Leaderboard year">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {years.map(y => (
              <SelectItem key={y} value={String(y)}>{y}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <LeaderboardTable
        leaderboard={rows}
        loading={loading}
        scope="global"
        emptyMessage={`No points yet for ${year}.`}
        emptyDescription="Members appear here once they make picks in a group tournament."
      />
    </div>
  )
}
